import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=cffbc8bc&scoped=true&"
import script from "./TableForm.vue?vue&type=script&lang=js&"
export * from "./TableForm.vue?vue&type=script&lang=js&"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=cffbc8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffbc8bc",
  null
  
)

export default component.exports